import { CreditCard, Bell } from "lucide-react";

// Field types: text, textarea, date, number, select
export const RESOURCES = {
  subscriptions: {
    type: "subscription", title: "My Subscriptions", icon: CreditCard,
    subtitle: "Never lose track of renewals, trials and memberships.",
    addLabel: "Add Subscription", empty: "Track subscriptions so Suffle can remind you before renewals.",
    statuses: ["active", "trial", "expiring", "cancelled"],
    fields: [
      { key: "title", label: "Service", type: "text", required: true, placeholder: "Netflix" },
      { key: "plan", label: "Plan", type: "text" },
      { key: "renewal_date", label: "Renewal Date", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["active", "trial", "expiring", "cancelled"] },
    ],
  },
  reminders: {
    type: "reminder", title: "Reminders", icon: Bell,
    subtitle: "Suffle will remember important things for you.",
    addLabel: "Create Reminder", empty: "Suffle will remember important things for you.",
    statuses: ["upcoming", "urgent", "completed"],
    fields: [
      { key: "title", label: "Reminder", type: "text", required: true, placeholder: "Pay electricity bill" },
      { key: "category", label: "Category", type: "select", options: ["Order", "Payment", "Document", "Subscription", "Return", "Other"] },
      { key: "due_date", label: "When", type: "date" },
      { key: "status", label: "Priority", type: "select", options: ["upcoming", "urgent", "completed"] },
    ],
  },
};
